// LienAssist.js
import React from "react";
import { Link } from 'react-router-dom';
import styles from '../css/LienAssistPage.module.css';
import { useDocumentTitle } from "../hooks/useDocumentTitle";

function LienAssist() {
    useDocumentTitle("Lien Assist");
    return (
        <>
            <div className={styles.banner}>
                <h1 className={styles.bannerTitle}>Lien Assist Program</h1>
            </div>

            <div className={styles.contentWrapper}>
                <div className={styles.leftContent}>
                    <h2 className={styles.serviceDescription}>Our brand-new service - <b>Lien Assist</b> - makes the entire lien process quicker and easier, with less back and forth</h2>
                    <div className={styles.listWrapper}>
                        <ul>
                            <li><strong>Sewer Liens</strong></li>
                            <li><strong>Mowing Liens</strong></li>
                            <li><strong>Demolition Liens</strong></li>
                            <li><strong>Nuisance Liens</strong></li>
                        </ul>
                    </div>
                </div>
                <div className={styles.rightContent}>
                    <ul className="mt-2">
                        <li>
                            <strong>Clean, Uniform Documents</strong>
                            <ul>
                                <li>SRI eliminates uncertainty regarding lien amounts and associated fees.</li>
                                <li>SRI makes all documents uniform in style and content for clarity.</li>
                            </ul>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <strong>Noticing & Recordings</strong>
                            <ul>
                                <li>SRI creates and mails all legally required notices.</li>
                                <li>SRI records and releases all lien documents.</li>
                            </ul>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <strong>Experts On Hand</strong>
                            <ul>
                                <li>SRI has former Auditors and Treasurers on staff to answer any questions.</li>
                                <li>SRi provides in-depth user manuals, training videos, and knowledge base articles.</li>
                            </ul>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <strong>One Online hub</strong>
                            <ul>
                                <li>SRI archives all documents online for quick, 24/7 access.</li>
                                <li>SRI shares information seamlessly between municipalities and the county.</li>
                            </ul>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <strong>Much, Much More!</strong>
                            <ul>
                                <li>Generate reports to track the status of your outstanding liens.</li>
                                <li>View projected settlement distributions for easier balancing of funds</li>
                            </ul>
                        </li>
                    </ul>
                    <div className={styles.btnWrapper}>
                        <Link to="/support" className="btn mb-3 btn-primary" id="lapBtn">
                            Inquire about Lien Assist
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LienAssist;
